<template>
  <div class="kommo">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state d-flex align-items-center">
            <img
              src="/static/images/icons/kommo.png"
              alt="Kommo"
              class="crm-logo mr-2">
            <h4 class="mb-0">Kommo <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="kommo"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com o Kommo?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        :class="{ 'modal-lg': disabledOwnerId }"
        role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between align-items-center">
            <h4 class="modal-title">Configurar Kommo</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="errorAlert" />
            <div
              class="form-group row"
              v-if="kommoDomain">
              <label
                for="kommoDomain"
                class="col-sm-4 col-form-label">Domínio Kommo</label>
              <div class="col-sm-8">
                <p class="form-control-plaintext">
                  <a
                    class="link"
                    :href="'https://' + kommoDomain"
                    target="_blank"
                    rel="noopener noreferrer">
                    https://{{ kommoDomain }}
                  </a>
                </p>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário Kommo</label>
              <div class="col-sm-8">
                <select
                  class="form-control"
                  id="kommoOwnerId"
                  v-model="kommoOwnerId"
                  :disabled="disabledOwnerId">
                  <option
                    v-for="option in ownersOptions"
                    :key="option.value"
                    :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="disabledOwnerId"
              class="form-group row mb-0">
              <div class="col-sm-12">
                <section class="alert alert-warning mb-0">
                  <h5 class="alert-heading text-center">⚠️ Importante sobre sua integração com Kommo</h5>
                  <hr>
                  <p class="paragraph">
                    Percebemos que o seu usuário Kommo conectado na integração
                    <strong>não tem permissão de administrador</strong>.
                  </p>
                  <p class="paragraph">
                    Sem essa permissão, a Api4Com <strong>não consegue consultar a lista de usuários</strong>
                    da sua conta Kommo, o que é necessário para identificar corretamente
                    <strong>quem deve aparecer como responsável e criador das atividades</strong>.
                  </p>
                  <h5 class="text-center">O que isso significa na prática?</h5>
                  <p class="paragraph">
                    Sua integração vai continuar funcionando, porém
                    <strong>as atividades serão registradas sem responsável</strong>.
                  </p>
                  <p class="paragraph">
                    Se isso não atrapalhar seu uso, você pode seguir sem ajustes.
                    Mas, se quiser uma experiência completa, recomendamos solicitar aos administradores
                    da sua conta Kommo que <strong>liberem permissão de administrador</strong> para o usuário
                    utilizado na integração.
                  </p>
                  <h5 class="text-center">Ajuda sobre permissões Kommo?</h5>
                  <p class="paragraph">
                    Caso tenha dúvidas sobre as permissões de usuários Kommo, consulte o guia oficial Kommo:
                  </p>
                  <p class="paragraph text-center">
                    <a
                      class="link"
                      href="https://www.kommo.com/br/recursos/configuracoes-da-conta/permissoes-de-usuario/"
                      target="_blank"
                      rel="noopener noreferrer">
                      Ver documentação de permissões de usuário Kommo
                    </a>
                  </p>
                </section>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">Salvar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Kommo atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Kommo removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialKommo"
      title="Tutorial Kommo"
      video-url="https://www.youtube.com/embed/GL6Vk8RQAzQ" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationKommo',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      kommoOwnerId: null,
      ownersOptions: [],
      kommoDomain: null,
      disabledOwnerId: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations?filter[where][gateway]=kommo`)
          .then(integrations => {
            this.integration = integrations.pop()
            if (this.integration && this.integration.metadata) {
              if (this.integration.metadata.ownerId) this.kommoOwnerId = this.integration.metadata.ownerId
              if (this.integration.metadata.clientBaseUrl) {
                this.kommoDomain = this.integration.metadata.clientBaseUrl
              }
            }
            return resolve()
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    saveIntegration () {
      return new Promise(resolve => {
        this.error = null
        if (!this.configReady) {
          this.error = 'Houve um erro ao salvar a integração. Por favor, tente novamente.'
          return resolve()
        }

        const integrationParams = {
          gateway: 'kommo',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'kommo'
            }
          },
          metadata: {
            webhookUrl: process.env.API4COM_WEBHOOK_RECEIVER_URL,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)

        if (this.kommoOwnerId) integrationParams.metadata.ownerId = this.kommoOwnerId
        else delete integrationParams.metadata.ownerId

        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
            return resolve()
          })
          .catch(err => {
            this.error = err
          })
      })
    },
    toogleIntegration (event) {
      if (event.value === true) {
        return this.requestAuthorization()
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.error = null
      this.configReady = false
      this.loadOwners().then(_ => {
        this.disabledOwnerId = false
        this.configReady = true
      })
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.kommoOwnerId = null
          this.configReady = false
          this.disabledOwnerId = false
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    requestAuthorization () {
      return loopback
        .get(`/integrations/kommo/authorize-link`)
        .then(link => {
          window.open(link, '_self')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadOwners () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/kommo/owners`)
          .then(owners => {
            this.disabledOwnerId = false
            if (owners && owners.length > 0) {
              this.ownersOptions = []
              if (!this.kommoOwnerId) this.kommoOwnerId = owners[0].id
              owners.forEach(owner => {
                let text = owner.name
                if (owner.email) text += ` (${owner.email})`
                this.ownersOptions.push({
                  value: owner.id,
                  text
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => this.errorHandle(err))
      })
    },
    errorHandle (err) {
      if (err && err.response && err.response.status === 403) {
        this.disabledOwnerId = true
        this.configReady = true
      } else {
        this.error = {
          message: 'Houve um problema com a autenticação da integração. Talvez seja necessário reinstalar essa integração.'
        }
      }
    },
    openTutorial () {
      this.$refs.tutorialKommo.open()
    }
  },
  computed: {
    // TEL-2243: esta tela guarda `error` como string escrita por ela mesma. O
    // ErrorAlert so aceita objeto — sem este envelope a validacao de prop reprova
    // e a tela nao renderiza erro nenhum. Mesmo padrao das telas de CRM irmas.
    errorAlert () {
      if (!this.error) return null
      return typeof this.error === 'string' ? { lines: [this.error] } : this.error
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'kommo'
    }
  }
}
</script>

<style lang="scss" scoped>
.paragraph {
  font-size: 14px;
  text-align: justify;
}
.crm-logo {
  width: 28px;
  height: 28px;
  object-fit: contain;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Integration/Kommo.vue